'use strict';

var w3cIssuer = require('@trustvc/w3c-issuer');
var jsonldSignatures = require('jsonld-signatures');
var attachmentsContext = require('../context/attachments-context.json');
var bbsV1 = require('../context/bbs-v1.json');
var bolContext = require('../context/bill-of-lading.json');
var bolcContext = require('../context/bill-of-lading-carrier.json');
var cooContext = require('../context/coo.json');
var credentialsV1 = require('../context/credentials-v1.json');
var credentialsV2 = require('../context/credentials-v2.json');
var didV1 = require('../context/did-v1.json');
var invoiceContext = require('../context/invoice.json');
var jwsV1 = require('../context/jws-2020-v1.json');
var promissoryNoteContext = require('../context/promissory-note.json');
var qrCodeContext = require('../context/qrcode-context.json');
var renderContext = require('../context/render-method-context.json');
var trContext = require('../context/transferable-records-context.json');
var warehouseReceiptContext = require('../context/warehouse-receipt.json');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var jsonldSignatures__default = /*#__PURE__*/_interopDefault(jsonldSignatures);
var attachmentsContext__default = /*#__PURE__*/_interopDefault(attachmentsContext);
var bbsV1__default = /*#__PURE__*/_interopDefault(bbsV1);
var bolContext__default = /*#__PURE__*/_interopDefault(bolContext);
var bolcContext__default = /*#__PURE__*/_interopDefault(bolcContext);
var cooContext__default = /*#__PURE__*/_interopDefault(cooContext);
var credentialsV1__default = /*#__PURE__*/_interopDefault(credentialsV1);
var credentialsV2__default = /*#__PURE__*/_interopDefault(credentialsV2);
var didV1__default = /*#__PURE__*/_interopDefault(didV1);
var invoiceContext__default = /*#__PURE__*/_interopDefault(invoiceContext);
var jwsV1__default = /*#__PURE__*/_interopDefault(jwsV1);
var promissoryNoteContext__default = /*#__PURE__*/_interopDefault(promissoryNoteContext);
var qrCodeContext__default = /*#__PURE__*/_interopDefault(qrCodeContext);
var renderContext__default = /*#__PURE__*/_interopDefault(renderContext);
var trContext__default = /*#__PURE__*/_interopDefault(trContext);
var warehouseReceiptContext__default = /*#__PURE__*/_interopDefault(warehouseReceiptContext);

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const DID_V1_URL = "https://www.w3.org/ns/did/v1";
const VC_V1_URL = "https://www.w3.org/2018/credentials/v1";
const VC_V2_URL = "https://www.w3.org/ns/credentials/v2";
const BBS_V1_URL = "https://w3id.org/security/bbs/v1";
const BLS12381_2020_V1_URL = "https://w3id.org/security/suites/bls12381-2020/v1";
const JWS_V1_URL = "https://w3id.org/security/suites/jws-2020/v1";
const STATUS_LIST_2021_CREDENTIAL_URL = "https://w3id.org/vc/status-list/2021/v1";
const TR_CONTEXT_URL = "https://trustvc.io/context/transferable-records-context.json";
const RENDER_CONTEXT_URL = "https://trustvc.io/context/render-method-context.json";
const ATTACHMENTS_CONTEXT_URL = "https://trustvc.io/context/attachments-context.json";
const QRCODE_CONTEXT_URL = "https://trustvc.io/context/qrcode-context.json";
const BOL_CONTEXT_URL = "https://trustvc.io/context/bill-of-lading.json";
const BOLC_CONTEXT_URL = "https://trustvc.io/context/bill-of-lading-carrier.json";
const COO_CONTEXT_URL = "https://trustvc.io/context/coo.json";
const INVOICE_CONTEXT_URL = "https://trustvc.io/context/invoice.json";
const PROMISSORY_NOTE_CONTEXT_URL = "https://trustvc.io/context/promissory-note.json";
const WAREHOUSE_RECEIPT_CONTEXT_URL = "https://trustvc.io/context/warehouse-receipt.json";
const contexts = {
  [DID_V1_URL]: didV1__default.default,
  [VC_V1_URL]: credentialsV1__default.default,
  [VC_V2_URL]: credentialsV2__default.default,
  [BBS_V1_URL]: bbsV1__default.default,
  [BLS12381_2020_V1_URL]: bbsV1__default.default,
  [JWS_V1_URL]: jwsV1__default.default
};
const trContexts = {
  [TR_CONTEXT_URL]: trContext__default.default
};
const renderContexts = {
  [RENDER_CONTEXT_URL]: renderContext__default.default
};
const attachmentsContexts = {
  [ATTACHMENTS_CONTEXT_URL]: attachmentsContext__default.default
};
const qrCodeContexts = {
  [QRCODE_CONTEXT_URL]: qrCodeContext__default.default
};
const templateContexts = {
  [BOL_CONTEXT_URL]: bolContext__default.default,
  [BOLC_CONTEXT_URL]: bolcContext__default.default,
  [COO_CONTEXT_URL]: cooContext__default.default,
  [INVOICE_CONTEXT_URL]: invoiceContext__default.default,
  [PROMISSORY_NOTE_CONTEXT_URL]: promissoryNoteContext__default.default,
  [WAREHOUSE_RECEIPT_CONTEXT_URL]: warehouseReceiptContext__default.default
};
const CredentialContextVersion = {
  v1: VC_V1_URL,
  v2: VC_V2_URL
};
async function getDocumentLoader(additionalContexts) {
  const resultMap = /* @__PURE__ */ new Map();
  [
    contexts,
    trContexts,
    renderContexts,
    attachmentsContexts,
    qrCodeContexts,
    templateContexts,
    additionalContexts
  ].forEach((context) => {
    if (!context) return;
    Object.entries(context).forEach(([url, document]) => {
      resultMap.set(url, {
        contextUrl: null,
        document,
        documentUrl: url
      });
    });
  });
  const resolveDid = /* @__PURE__ */ __name(async (did) => {
    const { wellKnownDid } = await w3cIssuer.queryDidDocument({
      did
    });
    const result = {
      contextUrl: null,
      document: wellKnownDid,
      documentUrl: did
    };
    resultMap.set(did, result);
    return result;
  }, "resolveDid");
  const customDocLoader = /* @__PURE__ */ __name(async (url) => {
    let result;
    if (resultMap.has(url)) {
      result = resultMap.get(url);
      return result;
    }
    if (url.includes("did:")) {
      return resolveDid(url);
    }
    const results = await fetch(url, {
      redirect: "follow"
    });
    const resolveContext = {
      contextUrl: null,
      document: await results.json(),
      documentUrl: results.url
    };
    resultMap.set(url, resolveContext);
    return resolveContext;
  }, "customDocLoader");
  return jsonldSignatures__default.default.extendContextLoader(customDocLoader);
}
__name(getDocumentLoader, "getDocumentLoader");

exports.ATTACHMENTS_CONTEXT_URL = ATTACHMENTS_CONTEXT_URL;
exports.BBS_V1_URL = BBS_V1_URL;
exports.BLS12381_2020_V1_URL = BLS12381_2020_V1_URL;
exports.BOLC_CONTEXT_URL = BOLC_CONTEXT_URL;
exports.BOL_CONTEXT_URL = BOL_CONTEXT_URL;
exports.COO_CONTEXT_URL = COO_CONTEXT_URL;
exports.CredentialContextVersion = CredentialContextVersion;
exports.DID_V1_URL = DID_V1_URL;
exports.INVOICE_CONTEXT_URL = INVOICE_CONTEXT_URL;
exports.JWS_V1_URL = JWS_V1_URL;
exports.PROMISSORY_NOTE_CONTEXT_URL = PROMISSORY_NOTE_CONTEXT_URL;
exports.QRCODE_CONTEXT_URL = QRCODE_CONTEXT_URL;
exports.RENDER_CONTEXT_URL = RENDER_CONTEXT_URL;
exports.STATUS_LIST_2021_CREDENTIAL_URL = STATUS_LIST_2021_CREDENTIAL_URL;
exports.TR_CONTEXT_URL = TR_CONTEXT_URL;
exports.VC_V1_URL = VC_V1_URL;
exports.VC_V2_URL = VC_V2_URL;
exports.WAREHOUSE_RECEIPT_CONTEXT_URL = WAREHOUSE_RECEIPT_CONTEXT_URL;
exports.attachmentsContexts = attachmentsContexts;
exports.contexts = contexts;
exports.getDocumentLoader = getDocumentLoader;
exports.qrCodeContexts = qrCodeContexts;
exports.renderContexts = renderContexts;
exports.templateContexts = templateContexts;
exports.trContexts = trContexts;
